"use client";

import {useSession} from "next-auth/react";
import {useRouter} from "next/navigation";
import QrCode from "@/components/site/QrCode";
import {reworkDate} from "@/lib/helpers/reworkDate";
import {AddToCalendarButton} from "add-to-calendar-button-react";
import ApplyActivity from "@/app/(activities)/activities/[slug]/applyActivity";
import CWFButton from "@/components/ui/CWFButton";
import ReviewDialog from "@/components/reviews/ReviewDialog";
import ButtonPayment from "@/components/Payments/ButtonPayment";
import useAxiosAuth from "@/lib/hooks/useAxiosAuth";
import getStripe from "@/lib/utils/get-stripe";
import {Button} from "@/components/ui/button";

export default function PreRegisterActivity({idActivity, date_event, participants, place_max, name,isReview,ownerUser,price,currentUserId,isLoc = false}){
    const session = useSession();
    const router = useRouter();
    const axiosAuth = useAxiosAuth();
    const activityDate = new Date(date_event);
    const dateNow = new Date();

    const participantCount = participants.length;
    let isParticip = false;
    let isPaid = false;


    function askPayment(){
        axiosAuth.post('payments/create-session', {
            type : "ACT",
            activity_id:idActivity,
            redirect_module:'activity',
            redirect_id : idActivity
        }).then(res => {
            getStripe().then(stripe => {
                stripe.redirectToCheckout({
                    sessionId: res.data.data.session.id,
                })
            })
        })
    }
    if(session.status === "authenticated"){
        const userParticipate = participants.find(el => el.user_id === session.data.user.user.id)

        if(userParticipate){
            isParticip = true;

            if(price){
                if(userParticipate?.paid){
                    isPaid = true;
                }
            }else{
                isPaid = true;
            }
        }
    }


    console.log("IsPaid : ",isPaid)
    if(ownerUser === currentUserId){
        return <p className={"italic text-primary"}>{isLoc ? "Vous ne pouvez pas vous inscrire à votre propre location." : "Vous ne pouvez pas vous inscrire à votre propre activité."}</p>
    }

    if(ownerUser === session?.data?.user.user.id){
        return <p className={"italic text-primary"}>{isLoc ? "Vous ne pouvez pas vous inscrire à votre propre location." : "Vous ne pouvez pas vous inscrire à votre propre activité."}</p>
    }

    if(dateNow > activityDate){
        return (
            <div className={"flex flex-col items-center gap-y-4"}>
                <p className={"italic text-primary"}>{isLoc ? "La location est terminé vous ne pouvez plus vous inscrire." : "L'activité est terminé vous ne pouvez plus vous inscrire."}</p>
                {(isParticip && !isReview) &&(
                    <div>
                        <ReviewDialog activityId={idActivity} userId={session.data.user.user.id} ownerUser={ownerUser}/>
                    </div>
                )}
            </div>
        )
    }
    if(!isPaid && isParticip){
        return(
            <div className={"flex flex-col items-center gap-y-4"}>
                <Button onClick={() => askPayment()}>Payer</Button>
            </div>
        )
    }
    if (isParticip) {
        return (
            <div>
            <div className={"flex flex-col items-center gap-y-5"}>
                    <QrCode type={"activity"} id={idActivity}/>
                    <p className={"text-primary text-center font-bold"}>Vous êtes inscrit veuillez montrer ce QrCode à  l&apos;accueil</p>
                    <AddToCalendarButton
                        name={name}
                        options={["Apple", 'Google', "Outlook.com"]}
                        startDate={reworkDate(activityDate,false,'en')}
                        timeZone={"Europe/Paris"}
                        label={"Noter dans mon agenda"}
                        inline
                        listStyle={"modal"}
                    />
                </div>
            </div>
        )
    }

    if(participantCount === place_max){
        return (
            <p className={"italic text-primary"}>Le nombre de place maximale pour cet évennement est atteint.</p>
        )
    }

    return(
        <ApplyActivity activityId={idActivity} onSuccess={() => router.refresh()} price={price} />
    );

}